import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import Hero from './Components/Hero';
import Tabs from './Components/Tabs';
import Tab4 from './Components/Tab4';
 class Kontak extends Component {
  render() {
    return (
      <div className="kontak">
       <Hero
       title="Kontak"
       subtitle="Silahkan menghubungi kami bila ada pertanyaan atau masalah"
       />
       <Tabs></Tabs>
       <Tab4></Tab4>
      </div>
    )
  }
}

export default Kontak;